import { PureComponent } from "react";
import PropTypes from "prop-types";

import { TextComponent } from "common/form/fields/text";

import GoogleLookupWrapper from "./google_lookup_wrapper";

class AddressLookup extends PureComponent {
  constructor(props) {
    super(props);
    const { initialValue } = props;
    this.state = {
      inputValue: initialValue || "",
    };
  }

  // This is kinda hacky. When the place_changed fires, it changes the value of the input, but doesn't trigger the
  // onChange. We're interested in how many characters the user types in before they choose an address to see
  // the amount of time/typing saved.
  // This is also important because we might want to update the radius that we search for address around if we determine
  // that the results coming up are not relevant to the user
  handleInputChange = (event) => {
    this.setState({
      inputValue: event.target.value,
    });
  };

  render() {
    const { useStyledInput, disabled, onAddressSelect, label, autoComplete } = this.props;
    return (
      <GoogleLookupWrapper
        onAddressSelect={onAddressSelect}
        allowChangeInput
        autoComplete={autoComplete}
      >
        {(initializeLookup, handleInputChange) => {
          return (
            <TextComponent
              label={label}
              onInputRefSet={initializeLookup}
              onChange={(e) => {
                handleInputChange(e);
                this.handleInputChange(e);
              }}
              placeholder="Example: 745 Boylston St, Boston, MA 02116"
              value={this.state.inputValue}
              useStyledInput={useStyledInput}
              disabled={disabled}
              data-automation-id="address-lookup-field"
            />
          );
        }}
      </GoogleLookupWrapper>
    );
  }
}

AddressLookup.propTypes = {
  autoComplete: PropTypes.bool,
  onAddressSelect: PropTypes.func.isRequired,
  useStyledInput: PropTypes.bool,
  disabled: PropTypes.bool,
  initialValue: PropTypes.string,
  label: PropTypes.string,
};

AddressLookup.defaultProps = {
  autoComplete: true,
  disabled: false,
  useStyledInput: false,
  initialValue: "",
  label: "Address Lookup",
};

export default AddressLookup;
